import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OnboardingNotifications from "@/components/onboarding/OnboardingNotifications/OnboardingNotifications.vue";
import { OnboardingContainerTypeEnum } from "@/types/onboarding";
import { onboardingInjectionKey } from "@/utils/onboarding/onboardingInjectionKey";
import { provide } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsNotifications',
  setup(__props) {

provide(onboardingInjectionKey, {
  type: OnboardingContainerTypeEnum.Settings,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OnboardingNotifications))
}
}

})